import { motion } from "framer-motion";

export const GoldBadge = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider bg-amber-500/10 text-amber-400 border border-amber-500/30"
  >
    {children}
  </span>
);

export const GoldLine = ({ className = "" }) => (
  <div className={`h-[2px] w-16 bg-gradient-to-r from-amber-400 via-amber-600 to-transparent my-4 ${className}`} />
);

export const SectionHead = ({ eyebrow, title, description, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className="font-code text-xs sm:text-sm uppercase tracking-[0.2em] text-amber-400/90 mb-3">
        {eyebrow}
      </p>
    )}
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-50">
      {title}
    </h2>
    <GoldLine className={align === "center" ? "mx-auto" : ""} />
    {description && <p className="text-base sm:text-lg leading-relaxed text-slate-300">{description}</p>}
  </div>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((item, i) => (
      <li key={i} className="flex gap-3 text-slate-300 text-sm sm:text-base leading-relaxed">
        <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-amber-500" aria-hidden="true" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", baseDelay = 0.15 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          initial={{ y: "112%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: baseDelay + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
          className={lineClassName}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-amber-500/20 bg-[#0D111B] py-4 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display text-base sm:text-lg tracking-[0.18em] uppercase text-slate-400 px-7">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/70 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
